import { signing as base } from './base';
import { signing as AT } from './AT';
import { signing as CZ } from './CZ';
import { signing as HR } from './HR';
import { signing as HU } from './HU';
import { signing as RO } from './RO';
import { signing as SK } from './SK';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
};
